import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: (bordered?: boolean, disabled?: boolean, isText?: boolean) => ({
        borderRadius: '100px',
        padding: bordered ? '12.5px 20.5px' : '14.5px 22.5px',
        justifyContent: 'center',
        alignItems: 'center',
        ...(disabled && !isHosTheme && { opacity: 0.4 }),

        ':hover': {
            background: isText ? 'transparent' : theme.palette.common.black,
        },
    }),
    light: (bordered?: boolean, isText?: boolean) => ({
        color: isHosTheme ? theme.palette.secondary.dark : theme.palette.common.white,
        background: bordered || isText ? 'transparent' : theme.palette.common.white,
        border: bordered ? `2px solid ${theme.palette.common.black}` : undefined,

        ...(isHosTheme && {
            ':hover': {
                background:
                    bordered || isText ? theme.palette.primary.main : theme.palette.common.black,
                color: theme.palette.common.white,
                svg: css({
                    path: {
                        fill: `${theme.palette.common.white} !important`,
                    },
                }),
                borderColor: theme.palette.primary.main,
            },
            svg: css({
                path: {
                    fill: `${theme.palette.primary.main} !important`,
                },
            }),
            border: bordered ? `1px solid ${theme.palette.secondary.dark}` : undefined,
        }),
    }),
    primary: (bordered?: boolean) => ({
        color: bordered ? theme.palette.primary.main : theme.palette.common.white,
        background: bordered ? 'transparent' : theme.palette.primary.main,
        border: bordered ? `2px solid ${theme.palette.primary.main}` : undefined,

        '&.Mui-disabled': {
            color: bordered ? theme.palette.primary.main : theme.palette.common.white,
        },
    }),
    success: {
        color: theme.palette.common.white,
        background: theme.palette.success.main,

        '&.Mui-disabled': {
            color: theme.palette.common.white,
        },
    },
    spinner: {
        width: '28px',
        height: '28px',
        color: 'inherit',
        margin: '-7px auto',
        display: 'block',
    },
    content: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: !isHosTheme ? 'center' : 'space-between',
        textAlign: 'center',
        gap: '16px',
        flex: 1,
        ':hover': {
            border: 'none',
        },
        ...(!isHosTheme && { textTransform: 'uppercase' }),
        ...(isHosTheme && { marginTop: '2px' }),
    }),
};
